module.exports = "https://static.energy5.com/_next/static/images/evChargingBg-1e3b380ba2bd31c5bcba33087867ddc4.webp";